import { observable, action, runInAction, computed } from 'mobx'
import { message } from 'antd'
import { json, get } from '../../../../utils/ajax'
import {setStore} from "../../../../utils/Utils";

class EAtlasCarSeriesCatalogStore {

    @observable loading
    @observable list
    @observable tree
    @observable page
    @observable modal
    @observable modalSelect
    @observable brands
    @observable carSeries
    @observable brandId
    @observable carSeriesId
    @observable uploadCarseriesId
    @observable editFields
    @observable info
    @observable option
    @observable pagination
    @observable modalCarCopy//显示车系目录
    @observable editCarloading
    @observable oldCarId//用于存放老车系ID
    @observable newCarId//用于存放新车系ID
    @observable oldCarCatalog//用于存放老车系目录
    @observable oldCarCatalogID//用于存放老车系目录ID
    @observable newCarCatalog//用于存放新车系目录
    @observable newCarCatalogID//用于存放新车系目录ID
    @observable carseries//用于车系下拉框
    @observable editCatalogloading
    @observable oldCarCatalogLevel//用于存放老车系目录层级
    @observable newCarCatalogLevel//用于存放新车系目录层级
    @observable modalCatalogCopy//用于存放新车系目录层级
    @observable rowData
    @observable expandedLeftRowKeys
    @observable dragList
    @observable clickRowId
    @observable dragState //是否显示拖拽后保存按钮
    @observable carseriesId //点击查看目录需要的参数id
    @observable carseriesName //点击查看目录需要的参数名字


    constructor () {
        this.loading = false
        this.modalSelect = 'hide'
        this.modal = 'hide'
        this.list = []
        this.brandId = []
        this.carSeriesId = []
        this.uploadCarseriesId = []
        this.tree = []
        this.editFields = {}
        this.pagination = {}
        this.info = []
        this.option = []
        this.page = {
            current: 0,
            total: 1
        }
        this.brands = {
            list: [],
            selected: ''
        }
        this.carSeries = {
            list: [],
            selected: ''
        }
        this.modalCarCopy = false
        this.editCarloading = false
        this.oldCarId = ''
        this.newCarId = ''
        this.oldCarCatalog = []
        this.oldCarCatalogID = ''
        this.newCarCatalog = []
        this.newCarCatalogID = ''
        this.carseries = []
        this.editCatalogloading = false
        this.oldCarCatalogLevel = ''
        this.newCarCatalogLevel = ''
        this.modalCatalogCopy = false
        this.rowData = {}
        this.expandedLeftRowKeys = []
        this.dragList = []
        this.clickRowId = ''
        this.dragState = false
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 初始化页面
     */
    @action
    initListPage = async (page,value) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        let search = value || ''
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/carseriesCatalogs`, {
            page: page,
            carseriesName: search
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res.content
            this.page = {
                current: res.number + 1,
                total: res.totalElements
            }
        })
    }

    /**
     * 初始化品牌下拉框
     */
    @action
    initBrands = async () => {
        runInAction(() => {
            this.loading = true
            this.brands = {
                list: [],
                selected: ''
            }
            this.carSeries = {
                list: [],
                selected: ''
            }
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/brand:brandList`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.brands.list = res
            this.loading = false
            this.modalSelect = 'show'
        })
    }

    /**
     * 初始化车系下拉框
     */
    @action
    initCarseries = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/carseries/list/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.carSeries.list = res
            this.loading = false
        })
    }

    /**
     * 选中品牌
     */
    @action
    saveBrandId = (value) => {
        runInAction(() => {
            this.brandId = value
        })
    }

    /**
     * 选中车系
     */
    @action
    saveCarSeriesId = (value) => {
        runInAction(() => {
            this.carSeriesId = value
        })
    }

    /**
     * 保存选中的车系和品牌记录
     */
    @action
    saveCatalog = async () => {
        runInAction(() => {
            this.loading = true
        })
        //If NUll
        if (this.brandId.length === 0 || this.carSeriesId.length === 0) {
            message.warning('请选择品牌和车系')
            return
        }
        //获取品牌信息
        let brand = []
        const brandList = this.brands.list
        for (let i = 0; i < brandList.length; i++) {
            if (brandList[i].id === this.brandId) {
                brand = brandList[i]
            }
        }
        //获取车系信息
        let carSeries = []
        const carSeriesList = this.carSeries.list
        for (let i = 0; i < carSeriesList.length; i++) {
            if (carSeriesList[i].id === this.carSeriesId) {
                carSeries = carSeriesList[i]
            }
        }
        //构造
        const data = {
            'carseriesName': carSeries.defaultName,
            'carseriesImage': carSeries.icon,
            'carseriesId': carSeries.id,
            'rank': carSeries.rank,
            'isDelete': 0,
            'brandName': brand.defaultName,
            'brandId': brand.id,
            'state': 0
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/carseriesCatalog`, data)
        runInAction(() => {
            if(res.status===1){
                if(res.data==='新增成功'){
                    message.success(res.data)
                }else {
                    message.warning(res.data)
                }
            }
            this.loading = false
            this.modalSelect = 'hide'
        })
        this.initListPage(this.page)
    }

    /**
     *取消编辑
     */
    @action.bound
    cancelEdit () {
        this.loading = false
        this.modalSelect = 'hide'
    }

    /**
     * 删除车系记录
     * 2018/5/14  删除车系保留一段时间在干掉
     */
    @action
    deleteByCarseriesId = async (rocord) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/carseriesCatalog/${rocord.id}/${rocord.carseriesId}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
        })
        this.initListPage(this.page)
    }

    /**
     * 发布/撤销
     */
    @action
    publishByCarseriesId= async (rocord) => {
        runInAction(() => {
            this.loading = true
        })
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/list?carseriesId=${rocord.carseriesId}`)
        if(res1.length === 0){
            message.warning('该车系下没有目录，请先添加目录！');
            runInAction(() => {
                this.loading = false
            })
            return
        }
        let state = rocord.state? 0 : 1;
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/carseriesCatalog/${rocord.id}/state/${state}`)
        if (res && res.status === 0) {
            message.error('发布失败！');
            return
        }
        if(state === 1){
            message.success('发布成功！');
        }else{
            message.success('撤销成功！');
        }
        runInAction(() => {
            this.loading = false
        })
        this.initListPage(this.page)
    }

    /**
     *清空目录
     */
    @action.bound
    clearEditPage () {
        runInAction(() => {
            this.modal = 'hide'
            this.tree = []
        })
    }

    /**
     *初始化目录树表
     */
    @action
    initEditPage = async (carseriesId) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/list?carseriesId=${carseriesId}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
            this.tree = res
            let initList=[]
            res.map(item=>{
                initList.push({...item,children:''})
            })
            this.dragList=Array.isArray(res)?initList:[]
            this.uploadCarseriesId = carseriesId
        })
    }

    /**
     *显示1级输入框
     */
    @action
    showAddFirstBox = () => {
        runInAction(() => {
            this.option="addFrist"
            this.loading = true
            this.editFields.content = ''
            this.modal = 'show'
            this.loading = false
        })
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action.bound
    onEditFieldChange (changedFields) {
        const fields = {...this.fields, ...changedFields}
        let editFields = {
            defaultName: fields.defaultName.value,
            numbered: fields.numbered.value,
        }
        this.editFields = editFields
    }

    /**
     * 平行化表单，传值给form
     */
    @computed get fields () {
        let fields = {
            defaultName: {value: this.editFields.defaultName},
            numbered: {value: this.editFields.numbered},
        }
        return fields
    }

    /**
     * 新增一级目录
     * 新增同级目录
     * 新增下级目录
     * 修改目录
     */
    @action
    operation = async (content, info, option) => {
        //新增一级
        runInAction(() => {
            this.loading = true
            this.editFields.defaultName = ''
            this.editFields.numbered = ''
        })
        let data = {
            'carseriesId': this.uploadCarseriesId,
            'defaultName': content.defaultName,
            'numbered':content.numbered,
        }
        if(option === 'update'){
            data.id=info.id
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/update`, data)
        }else  {
            if (option === 'addSame') {
                data.level=info.level
                data.pId=info.pId
            } else if (option === 'addChild') {
                data.level=info.level+1
                data.pId=info.id
            }else {//addFirt
                data.level=1
                data.pId='0'
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/create`, data)
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/list?carseriesId=${this.uploadCarseriesId}`)
        runInAction(() => {
            this.tree = res
            let initList=[]
            res.map(item=>{
                initList.push({...item,children:''})
            })
            this.rowData.id?this.clickRow(this.rowData):this.dragList=Array.isArray(res)?initList:[]
            this.loading= false
            this.modal = 'hide'
        })
    }

    //关闭
    @action
    closeBox = () => {
        this.modal = 'hide'
        this.modalCarCopy = false
        this.editFields = {}
    }

    /**
     * 删除目录
     */
    @action
    deleteOne = async (record) => {
        runInAction(() => {
            this.loading = true
        })
        await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/delete?id=${record.id}`)
        message.success('删除成功')
        if(this.tree.slice().length === 1){
            let state = 0
            const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/carseriesCatalog/${record.carseriesId}`)
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/carseriesCatalog/${res1.id}/state/${state}`)
        }
        runInAction(() => {
            this.loading = false
        })
        this.initEditPage(record.carseriesId)
    }

    /**
     * 显示
     */
    @action
    showBox = (record, option) => {
        if(option === 'update'){
            runInAction(()=>{
                this.editFields.defaultName = record.defaultName
                this.editFields.numbered = record.numbered
            })
        }else{
            runInAction(()=>{
                this.editFields.defaultName = ''
                this.editFields.numbered = ''
            })
        }
        runInAction(() => {
            this.loading = true
            this.info = record
            this.option = option
            this.modal = 'show'
            this.loading = false
        })
    }

    /**
     * 取老车系ID
     */
    @action oldCar = (value) => {
        this.oldCarId = value;
    }

    /**
     * 取新车系ID
     */
    @action newCar = (value) => {
        this.newCarId = value;
    }


    /**
     * 老车系目录树
     */
    @action
    initOldCarDirectory = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/list?carseriesId=${this.oldCarId}`)
        if (res.length === 0) {
            message.warning('该车系没有目录！')
            runInAction(() => {
                this.oldCarCatalog = [];
            })
            return
        }
        runInAction(() => {
            this.oldCarCatalog = res
        })
    }

    /**
     * 新车系目录树
     */
    @action
    initNewCarDirectory = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/list?carseriesId=${this.newCarId}`)
        if (res.length === 0) {
            runInAction(() => {
                this.newCarCatalog = [];
            })
        }
        runInAction(() => {
            this.newCarCatalog = res
            let data = this.carseries.find(item=>item.carseriesId===this.newCarId)
            if(data&&data.copyStatus===1){
                this.newCarId = ''
                message.warning(`车系正在复制中!`)
            }
        })
    }

    /**
     * 老车系目录树
     */
    @action
    initOldDirectory = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/list?carseriesId=${this.oldCarId}`)
        if (res.length === 0) {
            message.warning('该车系没有目录！')
            runInAction(() => {
                this.oldCarCatalog = [];
            })
            return
        }
        runInAction(() => {
            if(res.length===0){
                this.oldCarId=''
                message.warning(`该车系无目录，请重新选择车系！`)
            }
        })
    }

    /**
     * 新车系目录树
     */
    @action
    initNewDirectory = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/list?carseriesId=${this.newCarId}`)
        runInAction(() => {
            if (res.length === 0) {
                this.newCarCatalog = [];
            }
            if(res.length>0){
                this.newCarId = ''
                message.warning(`该车系已存在目录，请重新选择车系！`)
            }
            let data = this.carseries.find(item=>item.carseriesId===this.newCarId)
            if(data&&data.copyStatus===1){
                this.newCarId = ''
                message.warning(`车系正在复制中!`)
            }
        })
    }

    /**
     * 车系复制
     */
    @action carCopy = async () => {
        this.editCarloading=true
        if (this.oldCarId !== '' && this.newCarId !== '') {
            if(this.newCarCatalog.length > 0){
                message.warning('该车系下已有目录！')
                runInAction(() => {
                    this.loading = false
                })
                return
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/carseriesCatalog/copyStatus/${this.newCarId}`)
            await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/copy?originalCarId=${this.oldCarId}&newCarId=${this.newCarId}&originalCatalogId=${this.oldCarCatalogID}&newCatalogId=${this.newCarCatalogID}`)
        } else {
            message.warning('请选择新老车系！')
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            message.warning(`车系正在复制中，请勿操作！`)
            this.oldCarId = ''
            this.newCarId = ''
            this.oldCarCatalog = []
            this.newCarCatalog = []
            this.carseries = []
            this.modalCarCopy = false
            this.editCarloading=false
            this.initListPage()
        })
    }

    //关闭
    @action
    closeEditCarCopy = async () => {
        this.empty()
        runInAction(() => {
            this.loading = true
            this.modal = 'hide'
            this.modalCatalogCopy = false
            this.modalCarCopy = false
            this.loading = false
            this.oldCarId = ''
            this.newCarId = ''
            this.newCarCatalogLevel = ''
        })
    }

    /**
     * 清空
     */
    @action empty = () => {
        runInAction(() => {
            this.oldCarId = ''
            this.oldCarCatalogID = ''
            this.newCarId = ''
            this.newCarCatalogID = ''
            this.oldCarCatalog = []
            this.newCarCatalog = []
        })
    }

    /**
     * 初始化车系
     */
    @action initCarseriesList = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/carseriesCatalogs/list`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.carseries = res
        })
    }

    @action
    isShowCopyModel=()=>{
        this.oldCarId = ''
        this.newCarId = ''
        this.modalCatalogCopy = true
    }

    @action
    isShowCarCopyModel=()=>{
        this.oldCarId = ''
        this.newCarId = ''
        this.modalCarCopy = true
    }

    /**
     * 目录复制
     */
    @action catalogCopy = async () => {
        this.editCatalogloading=true
        if (this.oldCarCatalogID !== '' && this.oldCarId !== '' && this.newCarId !== '') {
            if (this.oldCarCatalogLevel===this.newCarCatalogLevel+1||(this.oldCarCatalogLevel===1&&!this.newCarCatalogLevel)){
                await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/copy?originalCarId=${this.oldCarId}&newCarId=${this.newCarId}&originalCatalogId=${this.oldCarCatalogID}&newCatalogId=${this.newCarCatalogID}`)
            } else {
                message.warning('选择新老车系目录层级不正确，请检查！')
                runInAction(() => {
                    this.loading = false
                    this.editCatalogloading=false
                })
                return
            }
        } else {
            message.warning('请选择新老车系目录！')
            runInAction(() => {
                this.loading = false
                this.editCatalogloading=false
            })
            return
        }
        runInAction(() => {
            this.initListPage(this.page)
            this.editCatalogloading=false
            this.oldCarId = ''
            this.oldCarCatalogID = ''
            this.newCarId = ''
            this.newCarCatalogID = ''
            this.oldCarCatalog = []
            this.newCarCatalog = []
            this.carseries = []
            this.modalCatalogCopy = false
        })
    }

    /**
     * 清空老车系目录
     */
    @action emptyOldCarCatalog = () => {
        this.oldCarCatalog = []
    }

    /**
     * 清空新车系目录
     */
    @action emptyNewCarCatalog = () => {
        this.newCarCatalog = []
    }

    /**
     * 获取老车系目录树ID
     */
    @action getTheOldCarCatalogTreeID = (directoryId,level) => {
        this.oldCarCatalogID = directoryId[0]
        if(directoryId.length===0){
            this.oldCarCatalogLevel = ''
        }else {
            this.oldCarCatalogLevel = level
        }
    }

    /**
     * 获取新车系目录树ID
     */
    @action getTheNewCarCatalogTreeID = (directoryId,level) => {
        this.newCarCatalogID = directoryId[0]
        if(directoryId.length===0){
            this.newCarCatalogLevel = ''
        }else {
            this.newCarCatalogLevel = level
        }
    }

    /****
     * 点击行数据
     */
    @action
    clickRow=async (record)=>{
        this.rowData=record
        if(!record.children){
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/${record.id}`)
            runInAction(()=>{
                this.dragList=[res]
            })
        }else {
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/Catalog/querySubordinateDirectoriesByDirectoryId/${record.id}`)
            runInAction(()=>{
                this.dragList=Array.isArray(res)?res:[]
            })
        }
    }
    /**
     * 展开的行变化时触发
     * @param expandedRows
     */
    @action
    changeExpandedLeftRowKeys=(expandedRows)=>{
        this.expandedLeftRowKeys = expandedRows
    }

    /***
     * 保存排序
     * @returns {Promise<void>}
     */
    @action
    saveSort=async ()=>{
        let dragList = []
        this.dragList.forEach((item, index) => {
            dragList.push({
                id: item.id,
                sort: index + 1
            })
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/Catalog/modifySort`,dragList)
        if (res && res.status === 0) {
            return
        }
        runInAction(()=>{
            this.dragState = false
        })
        await this.initEditPage(this.uploadCarseriesId)
        this.rowData.id&&await this.clickRow(this.rowData)
    }

    /***
     * PDF上传
     * @param info
     */
    @action
    pdfUpload=async (info)=>{
        this.loading=true
        let obj={
            pdfName:info.file.name,
            pdfUrl:info.file.response,
            id:this.clickRowId
        }
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/carseriesCatalog/update`,obj)
        runInAction(()=>{
            this.loading=false
            this.initListPage()
        })
    }
}
export default new EAtlasCarSeriesCatalogStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/EAtlas/EAtlasCarSeriesCatalog/store.js